<div class="pop-modal-container pop-inputs"
     (click)="closeModal()">


  <div class="pop-modal box-layout"
       (click)="$event.stopPropagation()">
    <h2 translate="MODAL.NEW_ESTIM"> </h2>

    <div class="body">

      <div class="spacer"></div>
      <pop-settings-box labelKey="PROPERTY_MODAL.TYPE">
        <pop-radio-button-group [options]="estimateTypeValues"
                                [(selectedOption)]="selectedEstimateType"></pop-radio-button-group>
      </pop-settings-box>

      <div class="spacer"></div>
      <h2 translate="TOOLBAR.PROJECT"></h2>
      <pop-settings-box labelKey="TOOLBAR.PROJECT">
        <pop-project-picker styleClass="rem-fix"
                            class="text-box large"
                            (selectedProjectChange)="onSelectProject($event)"></pop-project-picker>
      </pop-settings-box>


      <pop-settings-box labelKey="PROPERTY_MODAL.PROJ_TITLE">
        <input autocomplete="off"
               [disabled]="!isEstimateTypeNew || !selectedProject"
               type="text"
               class="text-box"
               pInputText
               [(ngModel)]="description" />
      </pop-settings-box>


      <pop-settings-box labelKey="PROPERTY_MODAL.REF">
        <input autocomplete="off"
               [disabled]="!selectedProject"
               type="text"
               class="text-box"
               [(ngModel)]="referenceCode"
               pInputText />
      </pop-settings-box>
      <pop-settings-box labelKey="PROPERTY_MODAL.COMPANY">
        <pop-select [options]="companies"
                    [disabled]="!selectedProject || !isEstimateTypeNew"
                    [disableEmptyOption]="true"
                    class="text-box"
                    keyField="code"
                    labelField="code"
                    [(selectedOption)]="selectedCompanyCode"></pop-select>
      </pop-settings-box>
      <pop-settings-box labelKey="HEADER.CLIENT">
        <pop-select [options]="customers"
                    [disabled]="!selectedCompanyCode || !isEstimateTypeNew"
                    keyField="customerId"
                    class="text-box"
                    labelField="customerName"
                    [(selectedOption)]="selectedCustomerNumber"></pop-select>
      </pop-settings-box>


      <pop-settings-box labelKey="HEADER.CLIENT_CONTACT">
        <input autocomplete="off"
               [disabled]="!selectedProject || !isEstimateTypeNew"
               type="text"
               class="text-box"
               [(ngModel)]="contact"
               pInputText />
      </pop-settings-box>

      <pop-settings-box labelKey="PROPERTY_MODAL.CURRENCY_CODE">
        <pop-select [options]="currencies"
                    class="text-box"
                    [disabled]="!selectedCompanyCode || !isEstimateTypeNew"
                    keyField="currencyCode"
                    labelField="currencyCode"
                    [disableEmptyOption]="true"
                    [(selectedOption)]="selectedCurrencyCode"></pop-select>
      </pop-settings-box>

      <pop-settings-box labelKey="PROPERTY_MODAL.DEPARTMENT_CODE">
        <pop-select [options]="departments"
                    class="text-box"
                    [disabled]="!selectedProject || !isEstimateTypeNew"
                    keyField="code"
                    labelField="code"
                    [disableEmptyOption]="true"
                    [(selectedOption)]="selectedDepartmentCode"></pop-select>
      </pop-settings-box>

      <pop-settings-box *ngIf="config?.activateInternalFees"
                        labelKey="OPTIONS.LIMIT_INTERNAL_RESOURCE_BILLING_METHOD">

        <pop-switch *ngIf="config"
                    [(isSwitched)]="config.limitInternalResourcesByBillingMethod">
        </pop-switch>
      </pop-settings-box>

      <div class="spacer"></div>
      <h2 translate="PROPERTY_MODAL.BILLING"></h2>


      <pop-settings-box labelKey="HEADER.RATE">
        <input autocomplete="off"
               type="number"
               class="text-box"
               [disabled]="!isEstimateTypeNew"
               pInputText
               placeholder="0.00"
               [(ngModel)]="rate" />
      </pop-settings-box>

      <pop-settings-box labelKey="OPTIONS.MAX_BUDGETED">
        <pop-switch *ngIf="config"
                    [disabled]="config.forceMaxBudgeted"
                    [(isSwitched)]="config.useMaxBudgeted">
        </pop-switch>
      </pop-settings-box>
      <pop-settings-box labelKey="OPTIONS.USE_LABOR_BILLING_METHOD">
        <pop-switch *ngIf="config"
                    [disabled]="config.forceLaborBillingMethod"
                    [(isSwitched)]="config.useLaborBillingMethod">
        </pop-switch>
      </pop-settings-box>
      <div class="box-line">
        <div class="box billing-methods">
          <div class="box-item">
            <span translate="PROPERTY_MODAL.LABOR_BILLING_METHOD"></span>
            <pop-select [options]="(laborBillingMethodCodes$ | async)"
                        class="text-box"
                        [disabled]="!selectedProject"
                        [(selectedOption)]="selectedLaborBillingMethodCode"></pop-select>
          </div>
          <div class="box-item">
            <span translate="PROPERTY_MODAL.EXPENSE_BILLING_METHOD"></span>
            <pop-select [options]="(expenseBillingMethodCodes$ | async)"
                        class="text-box"
                        [disabled]="!selectedProject"
                        [(selectedOption)]="selectedExpenseBillingMethodCode"></pop-select>
          </div>
          <div *ngIf="config?.activateInternalFees"
               class="box-item">
            <span translate="PROPERTY_MODAL.INTERNAL_FEE_BILLING_METHOD"></span>

            <pop-select [options]="(internalFeeBillingMethodCodes$ | async)"
                        class="text-box"
                        [disabled]="!selectedProject"
                        [(selectedOption)]="selectedInternalFeeBillingMethodCode"></pop-select>
          </div>
        </div>
      </div>

      <div class="spacer"></div>
      <h2 translate="HEADER.BUDGET_TYPE"></h2>

      <div class="box">

        <pop-estimate-budget-types *ngIf="config"
                                   [(estimateBudgetTypes)]="estimateBudgetTypes"
                                   [disabled]="!selectedProject || !isEstimateTypeNew"
                                   [settings]="config">
        </pop-estimate-budget-types>
      </div>

      <div class="spacer"></div>
      <h2 translate="PROPERTY_MODAL.OTHER"></h2>

      <pop-settings-box labelKey="HEADER.PROJECT_LEAD">

        <pop-select [options]="resources"
                    [disabled]="!selectedProject  || !isEstimateTypeNew"
                    keyField="id"
                    labelField="name"
                    class="text-box"
                    [(selectedOption)]="selectedProjectManagerId"></pop-select>
      </pop-settings-box>

      <pop-settings-box labelKey="MODAL.MODEL">

        <pop-select [options]="projectTemplates"
                    [disabled]="!isEstimateTypeNew"
                    class="text-box"
                    [disableEmptyOption]="true"
                    [(selectedOption)]="selectedProjectTemplateCode"></pop-select>

      </pop-settings-box>

      <pop-settings-box labelKey="MODAL.START_DATE">

        <div class="text-box">

          <pop-date-picker-input [(date)]="startDate"
                                 [minDate]="minDate"
                                 [isDisabled]="!isEstimateTypeNew"></pop-date-picker-input>

        </div>
      </pop-settings-box>

      <pop-settings-box labelKey="MODAL.END_DATE">

        <div class="text-box">
          <pop-date-picker-input [(date)]="endDate"
                                 [minDate]="startDate"
                                 [isDisabled]="!isEstimateTypeNew"></pop-date-picker-input>
        </div>

      </pop-settings-box>

      <div class="spacer"></div>
    </div>
    <div class="footer">
      <button class="save-btn rem-fix"
              [disabled]="!selectedProject || !selectedCompanyCode"
              (click)="onSubmit()"
              translate="BUTTON.CONFIRM">
      </button>
      <button class="cancel-btn rem-fix"
              translate="BUTTON.CANCEL"
              (click)="closeModal()">
      </button>
    </div>
  </div>
</div>
